import { BrowserDocumentService } from 'pf-frontend-common/src/service/browser-document/service';

import { AssetLoaderCss } from 'common/module/asset/loader/css';

export function AssetLoaderCssFactory(): AssetLoaderCss {
  return new AssetLoaderCss(BrowserDocumentService());
}
